import { render, staticRenderFns } from "./DataProcessor.vue?vue&type=template&id=7ec3c642&scoped=true"
import script from "./DataProcessor.vue?vue&type=script&lang=js"
export * from "./DataProcessor.vue?vue&type=script&lang=js"
import style0 from "./DataProcessor.vue?vue&type=style&index=0&id=7ec3c642&prod&lang=scss"
import style1 from "./DataProcessor.vue?vue&type=style&index=1&id=7ec3c642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec3c642",
  null
  
)

export default component.exports